import { Flex } from "@ifood/pomodoro-components";
import styled from "styled-components";

export const DrawerBody = styled(Flex)`
  padding: 16px;
  height: 100%;
  overflow-y: auto;
  flex-direction: column;
`;
